import {
  Box,
  Card,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import Row from './Row';
import { isEmpty } from 'lodash';
import { TableHeadCustom } from 'src/components/table';

type Props = {
  columns?: { id: string; label: string; align: string }[];
  data?: any;
  title?: string;
  page: number;
  count: number;
  rowsPerPage: number;
  onChangePage: (event: unknown, newPage: number) => void;
  onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRefresh: VoidFunction;
  actions?: any;
  menuItems?: any;
  width?: number;
};

export default function SummaryTable({
  columns,
  data,
  page,
  count,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
  handleRefresh,
  actions,
  menuItems,
  width,
}: Props) {
  return (
    <Card style={{ boxShadow: 'none', position: 'static' }} sx={{ m: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <TableContainer>
            <Stack direction="row" justifyContent="left" sx={{ m: 0 }}>
              <Grid container display={'flex'} alignItems={'center'} paddingRight={2}>
                <Grid
                  sx={{ position: 'absolute', top: '25px', right: '25px' }}
                  item
                  xs={2}
                  display={'flex'}
                  justifyContent={'flex-end'}
                >
                  {actions}
                </Grid>
              </Grid>
            </Stack>
            <Table size="small" sx={{ mb: 2 }}>
              <TableHeadCustom headLabel={columns || []} />
              <TableBody>
                {!isEmpty(data) ? (
                  data?.map((row: any, index: number) => (
                    <Row
                      key={row.id || index}
                      row={row}
                      handleRefresh={handleRefresh}
                      menuItems={menuItems?.(row)}
                      width={width}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns?.length}>
                      <Typography variant="body2" align="center">
                        No rows
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Box sx={{ position: 'relative' }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page - 1}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
        />
      </Box>
    </Card>
  );
}
